export const validateNameSurname = name => {
  if (name) {
    const nameRegex = /^[\p{L}]+(?: ?- ?[\p{L}]+)*(?: [\p{L}]+(?: ?- ?[\p{L}]+)*)*(?: utf8)?$/u;
    return nameRegex.test(name);
  }

  return true;
};